import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

/**
 * 기존 위험성평가 불러오기(GetRisCustom01R4) 시 실시(TB_SF_RISK_DETAIL) 초안을
 * Step02(RiskAssessmentF)에 넘기기 위한 컨텍스트.
 * 공정 키: MergeSafetyProcessListWithRiskDetails 결과의 gongJongCd(= Step01 processId).
 */
export const RisCustomWorkflowContext = createContext(null);

export function RisCustomWorkflowProvider({ children, waitRsCd }) {
  const [riskDetailOverlay, setRiskDetailOverlayState] = useState(null);
  const prevWaitRsCdRef = useRef(undefined);

  const setRiskDetailOverlay = useCallback((value) => {
    setRiskDetailOverlayState(value);
  }, []);

  const clearRiskDetailOverlay = useCallback(() => {
    setRiskDetailOverlayState(null);
  }, []);

  useEffect(() => {
    const cur = Number(waitRsCd);
    if (!Number.isFinite(cur) || cur <= 0) return;
    const prev = prevWaitRsCdRef.current;
    if (prev !== undefined && prev !== cur) {
      setRiskDetailOverlayState(null);
    }
    prevWaitRsCdRef.current = cur;
  }, [waitRsCd]);

  const value = useMemo(
    () => ({
      riskDetailOverlay,
      setRiskDetailOverlay,
      clearRiskDetailOverlay,
    }),
    [riskDetailOverlay, setRiskDetailOverlay, clearRiskDetailOverlay]
  );

  return (
    <RisCustomWorkflowContext.Provider value={value}>
      {children}
    </RisCustomWorkflowContext.Provider>
  );
}

export function useRisCustomWorkflow() {
  return useContext(RisCustomWorkflowContext);
}
